import { motion } from 'framer-motion';
import { RevealOnScroll } from './Motion';

export default function Flagship({ survey }) {
    if (!survey) return null;
    return (
        <section
            id="flagship"
            className="relative bg-ink text-sand-100 py-32 overflow-hidden"
            data-testid="flagship-section"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
                <RevealOnScroll>
                    <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] mb-8 text-emerald-signal">
                        <span className="w-8 h-px bg-emerald-signal" />
                        العرض المميز · #001
                    </div>
                </RevealOnScroll>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
                    <div className="lg:col-span-7">
                        <RevealOnScroll>
                            <h2 className="font-display font-black text-4xl md:text-6xl leading-[1.05] tracking-tight">
                                {survey.title.split('—')[0].trim()}
                                <br />
                                <span className="italic font-light text-emerald-signal">
                                    {survey.title.split('—')[1]?.trim() || 'العرض المميز'}
                                </span>
                            </h2>
                        </RevealOnScroll>
                        <RevealOnScroll delay={0.1}>
                            <p className="text-base md:text-lg text-sand-100/70 leading-relaxed mt-8 max-w-xl">
                                {survey.description}
                            </p>
                        </RevealOnScroll>

                        <RevealOnScroll delay={0.2}>
                            <div className="mt-10 grid grid-cols-3 gap-6 border-t border-sand-100/20 pt-8 max-w-lg">
                                <div>
                                    <div className="text-[10px] uppercase tracking-widest text-sand-100/60">
                                        المكافأة
                                    </div>
                                    <div className="font-display font-black text-2xl md:text-3xl text-emerald-signal mt-2">
                                        {survey.reward}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-[10px] uppercase tracking-widest text-sand-100/60">
                                        المدة
                                    </div>
                                    <div className="font-display font-black text-2xl md:text-3xl mt-2">
                                        {survey.duration}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-[10px] uppercase tracking-widest text-sand-100/60">
                                        المنصة
                                    </div>
                                    <div className="font-display font-black text-2xl md:text-3xl mt-2">
                                        {survey.provider}
                                    </div>
                                </div>
                            </div>
                        </RevealOnScroll>

                        <RevealOnScroll delay={0.3}>
                            <a
                                href={survey.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover-arrow inline-flex items-center gap-3 mt-10 px-8 py-4 bg-emerald-signal text-ink font-medium text-sm hover:bg-sand-100 transition-colors duration-500"
                                data-testid="flagship-cta"
                            >
                                سجّل الآن واحصل على مكافأة الترحيب
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path
                                        d="M13 7L1 7M1 7L7 1M1 7L7 13"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                    />
                                </svg>
                            </a>
                        </RevealOnScroll>
                    </div>

                    <RevealOnScroll delay={0.2} className="lg:col-span-5">
                        <motion.div
                            whileHover={{ scale: 1.02 }}
                            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                            className="relative aspect-[4/5] overflow-hidden border border-sand-100/20"
                        >
                            {survey.image_url && (
                                <img
                                    src={survey.image_url}
                                    alt={survey.title}
                                    className="w-full h-full object-cover"
                                />
                            )}
                            <div className="absolute inset-0 bg-gradient-to-t from-ink to-transparent opacity-60" />
                            <div className="absolute bottom-6 start-6 end-6">
                                <div className="text-[10px] uppercase tracking-[0.3em] text-sand-100/60 mb-2">
                                    مُختار محرّر الدليل
                                </div>
                                <div className="font-display font-black text-2xl">
                                    #{String(1).padStart(3, '0')} / {survey.provider}
                                </div>
                            </div>
                        </motion.div>
                    </RevealOnScroll>
                </div>
            </div>
        </section>
    );
}
